import React, { useCallback, useEffect, useMemo, useState } from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { cn } from '@lyearn/style';
import { Stack, StackProps } from '@lyearn/ui';
import BaseCardContext from '@/modules/content/components/ContentCard/BaseCard/Provider';
import { BaseCardContent } from '@/modules/content/components/ContentCard/BaseCard/types';
import { ContentCardTypeEnum } from '@/modules/content/config/cards';

import LongPressWrapper from '../Options/components/LongPressWrapper';

export interface BaseCardProps extends Omit<StackProps, 'content'> {
  content: BaseCardContent;
  cardType?: ContentCardTypeEnum;
  disabled?: boolean;
  overrideDefaultStyle?: string;
}

const BaseCard: React.FC<BaseCardProps> = (props) => {
  const { content, disabled = false, className, cardType, ...rest } = props;

  const [bookmarkState, setBookmarkState] = useState(content.bookmark);

  useEffect(() => {
    setBookmarkState(content.bookmark);
  }, [content.bookmark]);

  const onBookmarkUpdate = useCallback((id: string | undefined) => {
    setBookmarkState(id ? { id } : null);
  }, []);

  const contextValue = useMemo(
    () => ({ ...content, bookmark: bookmarkState, cardType, disabled, onBookmarkUpdate }),
    [content, bookmarkState, cardType, disabled, onBookmarkUpdate],
  );
  const { isMobile } = useScreen();

  return (
    <BaseCardContext.Provider value={contextValue}>
      {isMobile ? (
        <LongPressWrapper content={content}>
          <Stack className={cn('content-card', className)} {...rest} />
        </LongPressWrapper>
      ) : (
        <Stack className={cn('content-card group', className)} {...rest} />
      )}
    </BaseCardContext.Provider>
  );
};

export default BaseCard;
